import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import ChangePasswordModal from '@components/modal/changePasswordModal'
import ProfileModal from '@components/modal/profileModal'
import LogoutModal from '@components/modal/logoutModal'
import CompanyDisplay from '../companyDisplay'
import InsurerLogo from '../insurerLogo'

import { getProfile as getProfileAction } from '@actions/user'

import {
  Title, Container, Separator
} from './styles'

const PageHeader = ({
  profile, getProfile, authData
}) => {
  const [changePasswordModal, setChangePasswordModal] = useState(false)
  const [profileModal, setProfileModal] = useState(false)
  useEffect(() => {
    getProfile()
  }, [])

  if (!authData) return null

  return (
    <Container>
      <InsurerLogo
        style={{
          height: '27px',
          padding: '0 24px',
          alignSelf: 'center',
        }}
        disableClick={!!(authData.company || authData.programme)}
      />
      <Separator />
      <CompanyDisplay companyName={authData.company && authData.company.name} />
      <Separator />
      <Title>Relatórios de Saúde Preventiva</Title>
      <LogoutModal
        openChangePasswordModal={() => setChangePasswordModal(true)}
        openProfileModal={() => setProfileModal(true)}
        profile={profile}
        userName={authData.name && authData.name}
        company={authData.company && authData.company.name}
      />
      <ChangePasswordModal
        isOpen={changePasswordModal}
        setClose={() => setChangePasswordModal(false)}
      />
      <ProfileModal
        isOpen={profileModal}
        setClose={() => setProfileModal(false)}
      />
    </Container>
  )
}

PageHeader.propTypes = {
  profile: PropTypes.shape({
    name: PropTypes.string,
  }),
  getProfile: PropTypes.func.isRequired,
  authData: PropTypes.shape({
    company: PropTypes.shape({
      name: PropTypes.string,
    }),
    programme: PropTypes.shape({
      id: PropTypes.number,
    }),
    name: PropTypes.string,
  }),
}

PageHeader.defaultProps = {
  profile: {
    name: '',
  },
  authData: {
    company: {
      name: '',
    },
    user: {
      name: '',
    },
  },
}

const mapStateToProps = ({ user, auth }) => ({
  profile: user.profile,
  authData: auth.data,
})

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    getProfile: getProfileAction,
  },
  dispatch
)

export default connect(mapStateToProps, mapDispatchToProps)(PageHeader)
